export default __webpack_public_path__ + "static/media/resume_icon.abc196aa.svg";